
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; once per page load.

var $1FOPM = parcelRequire("1FOPM");


var $jv1SC = parcelRequire("jv1SC");

let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
    // Warms the chunk behind ConversationAssistantConfigurerV2's lazy boundary so the first chat open
    // does not pay for the download. Harmless when V2 is off: the module is part of the eagerly loaded
    // graph in that case, so the import resolves from cache.
    (0, $1FOPM.importConversationAssistantUI)().catch(()=>{});
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("1FOPM", function(module, exports) {
// Single-source dynamic import factory for the chat UI chunk.
// Mirrors `import-conversation-assistant.ts`: the shared `lazy()` boundary
// (`ConversationAssistantUILazy`), the control arm's warm in `ConversationAssistantConfigurer` and
// the intent-time preload all go through here so they share one chunk identity.

const $9c885de35cb434ea$export$94646181d4dabf90 = ()=>(parcelRequire("dwYHY"));
module.exports["importConversationAssistantUI"] = $9c885de35cb434ea$export$94646181d4dabf90;

});

parcelRegister("dwYHY", function(module, exports) {

let $9d9d5ae6aabd7eae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9d9d5ae6aabd7eae$var$load("ccAQf"),
    $9d9d5ae6aabd7eae$var$load("kwaPJ"),
    $9d9d5ae6aabd7eae$var$load("3ayyN"),
    $9d9d5ae6aabd7eae$var$load("52ggd"),
    $9d9d5ae6aabd7eae$var$load("hUbK8"),
    $9d9d5ae6aabd7eae$var$load("atmYP"),
    $9d9d5ae6aabd7eae$var$load("2putD"),
    $9d9d5ae6aabd7eae$var$load("d9LZs"),
    $9d9d5ae6aabd7eae$var$load("3Rwzg"),
    $9d9d5ae6aabd7eae$var$load("1rjMs"),
    $9d9d5ae6aabd7eae$var$load("b1RmF"),
    $9d9d5ae6aabd7eae$var$load("jOPdx"),
    $9d9d5ae6aabd7eae$var$load("dx5gy"),
    $9d9d5ae6aabd7eae$var$load("8aHht"),
    $9d9d5ae6aabd7eae$var$load("2mGc6"),
    $9d9d5ae6aabd7eae$var$load("cNslz"),
    $9d9d5ae6aabd7eae$var$load("d19Pa"),
    $9d9d5ae6aabd7eae$var$load("l6kfs"),
    $9d9d5ae6aabd7eae$var$load("6jUUE"),
    $9d9d5ae6aabd7eae$var$load("5lqi9"),
    $9d9d5ae6aabd7eae$var$load("iPvQ1"),
    $9d9d5ae6aabd7eae$var$load("cnE2c"),
    $9d9d5ae6aabd7eae$var$load("2YGw4"),
    $9d9d5ae6aabd7eae$var$load("3zwpG"),
    $9d9d5ae6aabd7eae$var$load("aMsb0"),
    $9d9d5ae6aabd7eae$var$load("2PXrC"),
    $9d9d5ae6aabd7eae$var$load("3g5Gh"),
    $9d9d5ae6aabd7eae$var$load("eIINb"),
    $9d9d5ae6aabd7eae$var$load("4gsXG"),
    $9d9d5ae6aabd7eae$var$load("9wcm8"),
    $9d9d5ae6aabd7eae$var$load("j1vz1"),
    $9d9d5ae6aabd7eae$var$load("l2JSg"),
    $9d9d5ae6aabd7eae$var$load("hh3iE"),
    $9d9d5ae6aabd7eae$var$load("bg4Qo"),
    $9d9d5ae6aabd7eae$var$load("ipIDQ"),
    $9d9d5ae6aabd7eae$var$load("gLJoQ"),
    $9d9d5ae6aabd7eae$var$load("8exG0"),
    $9d9d5ae6aabd7eae$var$load("bk398"),
    $9d9d5ae6aabd7eae$var$load("fHiQ2"),
    $9d9d5ae6aabd7eae$var$load("lkxmG"),
    $9d9d5ae6aabd7eae$var$load("kajPI"),
    $9d9d5ae6aabd7eae$var$load("axFWL"),
    $9d9d5ae6aabd7eae$var$load("2qUvH"),
    $9d9d5ae6aabd7eae$var$load("jeIi7"),
    $9d9d5ae6aabd7eae$var$load("ce05o"),
    $9d9d5ae6aabd7eae$var$load("6vqGz"),
    $9d9d5ae6aabd7eae$var$load("4XoWv"),
    $9d9d5ae6aabd7eae$var$load("7rfos"),
    $9d9d5ae6aabd7eae$var$load("dkfgY"),
    $9d9d5ae6aabd7eae$var$load("6wr18"),
    $9d9d5ae6aabd7eae$var$load("VXbA1"),
    $9d9d5ae6aabd7eae$var$load("7EorR"),
    $9d9d5ae6aabd7eae$var$load("by9qp"),
    $9d9d5ae6aabd7eae$var$load("i6gwF"),
    $9d9d5ae6aabd7eae$var$load("gnalD"),
    $9d9d5ae6aabd7eae$var$load("ffEVr"),
    $9d9d5ae6aabd7eae$var$load("hhss7"),
    $9d9d5ae6aabd7eae$var$load("Wowvf"),
    $9d9d5ae6aabd7eae$var$load("dFbDj"),
    $9d9d5ae6aabd7eae$var$load("cKDij"),
    $9d9d5ae6aabd7eae$var$load("aAWLw"),
    $9d9d5ae6aabd7eae$var$load("9SEo9")
]).then(()=>parcelRequire('8RDrG'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("drv0Z"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("drv0Z", function(module, exports) {

let $9c95dae4c680327d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9c95dae4c680327d$var$load("ccAQf"),
    $9c95dae4c680327d$var$load("kwaPJ"),
    $9c95dae4c680327d$var$load("3ayyN"),
    $9c95dae4c680327d$var$load("52ggd"),
    $9c95dae4c680327d$var$load("hUbK8"),
    $9c95dae4c680327d$var$load("gp3oF"),
    $9c95dae4c680327d$var$load("atmYP"),
    $9c95dae4c680327d$var$load("2putD"),
    $9c95dae4c680327d$var$load("d9LZs"),
    $9c95dae4c680327d$var$load("1rjMs"),
    $9c95dae4c680327d$var$load("b1RmF"),
    $9c95dae4c680327d$var$load("jOPdx"),
    $9c95dae4c680327d$var$load("dx5gy"),
    $9c95dae4c680327d$var$load("2mGc6"),
    $9c95dae4c680327d$var$load("cNslz"),
    $9c95dae4c680327d$var$load("d19Pa"),
    $9c95dae4c680327d$var$load("l6kfs"),
    $9c95dae4c680327d$var$load("6jUUE"),
    $9c95dae4c680327d$var$load("5lqi9"),
    $9c95dae4c680327d$var$load("iPvQ1"),
    $9c95dae4c680327d$var$load("cnE2c"),
    $9c95dae4c680327d$var$load("2YGw4"),
    $9c95dae4c680327d$var$load("3zwpG"),
    $9c95dae4c680327d$var$load("aMsb0"),
    $9c95dae4c680327d$var$load("2PXrC"),
    $9c95dae4c680327d$var$load("3g5Gh"),
    $9c95dae4c680327d$var$load("eIINb"),
    $9c95dae4c680327d$var$load("4gsXG"),
    $9c95dae4c680327d$var$load("9wcm8"),
    $9c95dae4c680327d$var$load("j1vz1"),
    $9c95dae4c680327d$var$load("l2JSg"),
    $9c95dae4c680327d$var$load("hh3iE"),
    $9c95dae4c680327d$var$load("bg4Qo"),
    $9c95dae4c680327d$var$load("ipIDQ"),
    $9c95dae4c680327d$var$load("gLJoQ"),
    $9c95dae4c680327d$var$load("8exG0"),
    $9c95dae4c680327d$var$load("bk398"),
    $9c95dae4c680327d$var$load("fHiQ2"),
    $9c95dae4c680327d$var$load("gnocL"),
    $9c95dae4c680327d$var$load("lkxmG"),
    $9c95dae4c680327d$var$load("VXbA1"),
    $9c95dae4c680327d$var$load("by9qp"),
    $9c95dae4c680327d$var$load("i6gwF"),
    $9c95dae4c680327d$var$load("gnalD"),
    $9c95dae4c680327d$var$load("cKDij"),
    $9c95dae4c680327d$var$load("kajPI"),
    $9c95dae4c680327d$var$load("axFWL"),
    $9c95dae4c680327d$var$load("2qUvH"),
    $9c95dae4c680327d$var$load("dFbDj"),
    $9c95dae4c680327d$var$load("6wr18"),
    $9c95dae4c680327d$var$load("4XoWv"),
    $9c95dae4c680327d$var$load("jeIi7"),
    $9c95dae4c680327d$var$load("ffEVr"),
    $9c95dae4c680327d$var$load("Wowvf"),
    $9c95dae4c680327d$var$load("6vqGz"),
    $9c95dae4c680327d$var$load("7rfos"),
    $9c95dae4c680327d$var$load("dkfgY"),
    $9c95dae4c680327d$var$load("hhss7"),
    $9c95dae4c680327d$var$load("7EorR"),
    $9c95dae4c680327d$var$load("ce05o"),
    $9c95dae4c680327d$var$load("aAWLw"),
    $9c95dae4c680327d$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.2bebc300.js.map
